import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import MovieGrid from './components/MovieGrid';
import FAQSection from './components/FAQSection';
import NewsletterSection from './components/NewsletterSection';
import { hotMovies, latestMovies, faqData } from '@/mocks/movies';

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '被窝网电影',
    url: 'https://www.beiwomovie.com',
    description: '被窝网电影是领先的免费高清影视资源聚合平台，提供海量电影、电视剧、动漫、综艺等优质内容在线观看。',
    contactPoint: {
      '@type': 'ContactPoint',
      email: 'contact@beiwomovie.com',
      contactType: 'customer service',
      availableLanguage: ['Chinese'],
    },
  };

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '被窝网电影',
    url: 'https://www.beiwomovie.com',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://www.beiwomovie.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqData.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />

      <Navbar />

      <main>
        <HeroSection />
        <CategoryNav />
        <div className="bg-background-50">
          <MovieGrid
            title="热门推荐"
            subtitle="全网热播影视，大家都在看"
            movies={hotMovies}
          />
        </div>
        <div className="bg-background-100">
          <MovieGrid
            title="最新上线"
            subtitle="每日更新，精彩不间断"
            movies={latestMovies}
            showType
          />
        </div>
        <FAQSection />
        <NewsletterSection />
      </main>

      <Footer />
    </>
  );
}